import { Component } from '../../base/Component';
import { clamp } from '../../utils/math';
/**
 * Launch an animation frame with a certain FPS
 */
export class AnimationFrame extends Component {
    constructor(initialProp, init = true) {
        super(initialProp, false);
        this._isPlaying = false;
        this._frame = null;
        this._frameIndex = -1;
        this._timeStamp = null;
        this._prevFrameTime = null;
        if (init) {
            this.init();
        }
    }
    get isPlaying() {
        return this._isPlaying;
    }
    /**
     * Get default properties
     */
    _getDefaultProp() {
        return Object.assign(Object.assign({}, super._getDefaultProp()), { fps: 140, run: false });
    }
    // Extra constructor
    _constructor() {
        super._constructor();
        this._create();
    }
    /**
     * Create the frame
     */
    _create() {
        if (this.prop.run) {
            this.play();
        }
    }
    _onPropMutate() {
        this._frameIndex = -1;
        this._timeStamp = null;
        this._prevFrameTime = null;
        if (this.prop.run) {
            this._play();
        }
        else {
            this._pause();
        }
    }
    /**
     * Launch the animation frame.
     */
    play() {
        if (this.destroyed) {
            return;
        }
        if (this.prop.run) {
            return;
        }
        this.changeProp({
            run: true,
        });
    }
    /**
     * Launch the animation frame.
     */
    _play() {
        // check if already playing
        if (this.isPlaying) {
            return;
        }
        this._isPlaying = true;
        // launch animation
        this._frame = window.requestAnimationFrame(this._animate.bind(this));
    }
    /**
     * Stop the animation frame
     */
    pause() {
        if (!this.prop.run) {
            return;
        }
        this.changeProp({
            run: false,
        });
    }
    /**
     * Stop the animation frame
     */
    _pause() {
        if (!this.isPlaying) {
            return;
        }
        // cancel animation frame
        if (this._frame) {
            window.cancelAnimationFrame(this._frame);
            this._frame = null;
        }
        // bool
        this._isPlaying = false;
    }
    /**
     * Launch the animation frame.
     */
    _animate(timestamp) {
        if (!this._isPlaying) {
            return;
        }
        // launch animation
        this._frame = window.requestAnimationFrame(this._animate.bind(this));
        // update variables
        const currentTime = +new Date();
        if (this._timeStamp == null) {
            this._timeStamp = timestamp;
        }
        if (this._prevFrameTime == null) {
            this._prevFrameTime = currentTime;
        }
        // calculate frame index
        const newFrameIndex = Math.floor((timestamp - this._timeStamp) / (1000 / this.prop.fps));
        if (newFrameIndex <= this._frameIndex) {
            return;
        }
        // update frame index
        this._frameIndex = newFrameIndex;
        // calculate real fps
        const timeDiff = currentTime - this._prevFrameTime;
        const realFPS = clamp(timeDiff === 0 ? 1000 / 60 : Math.floor(1000 / timeDiff), [1, Infinity]);
        // launch callbacks
        this.callbacks.tbt('frame', {
            fps: this.prop.fps,
            realFPS,
            prevFrameDuration: currentTime - this._prevFrameTime,
        });
        this._prevFrameTime = +new Date();
    }
    /**
     * Destroy the animation frame
     */
    _destroy() {
        this.pause();
        super._destroy();
    }
}
